


















import Vue, { PropType } from 'vue'
import Button from '@/types/components/Button.interface'
import HelpObject from '@/types/components/HelpObject.interface'
export default Vue.extend({
    props: {
        //  Determines if a bottom border is show
        divider: {
            type: Boolean,
            default: false
        },
        //  Our help dialog that appears next to the title
        help: {
            type: Object as PropType<HelpObject>,
            default: null
        },
        //  The buttons displayed on the left side
        left: {
            type: Array as PropType<Button[]>,
            default: null
        },
        //  The buttons displayed on the right side
        right: {
            type: Array as PropType<Button[]>,
            default: null
        },
        //  Applies the 'small' prop to buttons
        small: {
            type: Boolean,
            default: false
        },
        //  The subtitle
        subtitle: {
            type: String,
            default: null
        },
        //  The icon displayed to the left of the subtitle
        subtitleIcon: {
            type: String,
            default: null
        },
        //  The title
        title: {
            type: String,
            default: null
        }
    }
})
